import React from 'react';
import Dropdown from './Dropdown';
var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return /*#__PURE__*/React.createElement(Dropdown, props);
};
export default InputGroupButtonDropdown;